import imgQRNotActive from "../../../assets/images/qr-not-active.png";
import "../../../styling/style-qrpage-redirect.css";

const QRNotActive = () => {
    return (
        <section className="section-ensure-gold">
            <img 
                src={imgQRNotActive}
                alt="QR Not Active"
                className="img-ensure-gold"
            />
        </section>
    )
}
export default QRNotActive;